const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5001/api';

interface DeleteAccountResponse {
  success: boolean;
  data?: {
    userId: string;
    deletedCollections: Record<string, number>;
    membershipCancelled: boolean;
  };
  error?: {
    message: string;
  };
}

export const deleteUserAccount = async (idToken: string): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/users/me`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
  });

  if (!response.ok) {
    let errorMessage = 'Failed to delete account';
    try {
      const errorData: DeleteAccountResponse = await response.json();
      errorMessage = errorData.error?.message || errorMessage;
    } catch {
      // Ignore JSON parsing errors
    }
    throw new Error(errorMessage);
  }

  // Optionally parse response to ensure the request completed
  try {
    await response.json();
  } catch {
    // Some deployments might not return a JSON body; that's fine
  }
};
